var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.72 9l7.78 15.313L.422 9h5.297zm15.56 0L13.5 24.313 26.578 9h-5.297z",
    fill: "#EA6C00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDB300",
    d: "M5.72 9h15.56L13.5 24.313z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5.688l-7.371.777L5.719 9 13.5.687zm0 0l7.371.777.41 7.535L13.5.687z",
    fill: "#FDD231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.578 9l-5.707-7.535L21.28 9h5.3zM.422 9l5.707-7.535L5.719 9H.422z",
    fill: "#FDA700"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEEEB7",
    d: "M13.5.688L5.72 9h15.56z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6b38255f.svg";
export { ForwardRef as ReactComponent };